interface InfoRowProps {
  label: string;
  value?: string | null;
}

/**
 * InfoRow - Displays a label-value pair in a side panel
 *
 * Used for showing machine/entity details in a consistent format.
 * Label is fixed width, value takes remaining space with word wrap.
 *
 * @example
 * ```tsx
 * <InfoRow label="Machine ID" value={machine.machineId} />
 * ```
 */
export function InfoRow({ label, value }: InfoRowProps) {
  return (
    <div className='flex items-start gap-4'>
      <span className='size-p2 text-secondary w-32 shrink-0'>{label}</span>
      <span className='size-p2 text-primary min-w-0 flex-1 wrap-break-word'>
        {value || <span className='text-tertiary'>-</span>}
      </span>
    </div>
  );
}
